import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IMenuItem, IMenuItemWithRole } from "src/models/Maintenance/MenuItem.models";

interface MenuItemState {
  menuItems: IMenuItem[];
  menuItemsWithRoles: IMenuItemWithRole[];
  menuItemToEdit: IMenuItem | null;
}

const initialState: MenuItemState = {
  menuItems: [],
  menuItemsWithRoles: [],
  menuItemToEdit: null,
};

const menuItemSlice = createSlice({
  name: "MenuItem",
  initialState,
  reducers: {
    setMenuItemList: (state, action: PayloadAction<IMenuItem[]>) => {
      state.menuItems = action.payload;
    },
    concatListMenuItem: (
      state: MenuItemState,
      action: PayloadAction<IMenuItem[]>
    ) => {
      state.menuItems = [...state.menuItems.concat(action.payload)];
    },
    setMenuItemToEdit: (state, action: PayloadAction<IMenuItem | null>) => {
      state.menuItemToEdit = action.payload;
    },
    setMenuItemListWithRoles: (
      state,
      action: PayloadAction<IMenuItemWithRole[]>
    ) => {
      state.menuItemsWithRoles = action.payload;
    },
    addMenuItem: (state, action: PayloadAction<IMenuItem>) => {
      state.menuItems.push(action.payload);
    },
    updateMenuItem: (state, action: PayloadAction<IMenuItem>) => {
      let itemIndex = state.menuItems.findIndex(
        item => item.menuItemId === action.payload.menuItemId
      );
      if (itemIndex !== -1) state.menuItems[itemIndex] = action.payload;
    },
    deleteMenuItem: (state, action: PayloadAction<number>) => {
      const newArray = state.menuItems.filter(
        item => item.menuItemId !== action.payload
      );
      state.menuItems = newArray;
    },
  },
});

export const {
  setMenuItemList,
  concatListMenuItem,
  setMenuItemToEdit,
  setMenuItemListWithRoles,
  addMenuItem,
  updateMenuItem,
  deleteMenuItem,
} = menuItemSlice.actions;

export default menuItemSlice.reducer;
